/* Kesvara sconce light lab - canvas renderer. Scene: wall + furniture albedo, lit by two vertical LED bars on round magnetic bases. */
(function () {
  'use strict';
  var TONES = { warm: { k: 3000, c: [255, 170, 94] }, neutral: { k: 4000, c: [255, 206, 156] }, cool: { k: 6000, c: [226, 238, 255] } };
  var STEPS = [0.1, 0.3, 0.5, 0.75, 1];
  var BAR_HALF = 25, BAR_W = 1.5, DISC_R = 5.6;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function mix(a, b, t) { return a + (b - a) * t; }
  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function rr(c, x, y, w, h, r) { r = Math.min(r, w / 2, h / 2); c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath(); }
  function rgba(c, a) { return 'rgba(' + (c[0] | 0) + ',' + (c[1] | 0) + ',' + (c[2] | 0) + ',' + a + ')'; }

  var noiseTile = null;
  function noise() {
    if (noiseTile) return noiseTile;
    var n = document.createElement('canvas'); n.width = n.height = 192;
    var c = n.getContext('2d'), d = c.createImageData(192, 192), r = rng(7);
    for (var i = 0; i < d.data.length; i += 4) { var v = r() * 255; d.data[i] = d.data[i + 1] = d.data[i + 2] = v; d.data[i + 3] = 22 + r() * 22; }
    c.putImageData(d, 0, 0); noiseTile = n; return n;
  }
  function grain(c, w, h, alpha) { c.save(); c.globalAlpha = alpha; c.fillStyle = c.createPattern(noise(), 'repeat'); c.fillRect(0, 0, w, h); c.restore(); }
  function blob(c, x, y, r, a, col, sx, sy) {
    c.save(); c.translate(x, y); c.scale(sx || 1, sy || 1);
    var g = c.createRadialGradient(0, 0, 0, 0, 0, r);
    g.addColorStop(0, rgba(col, a)); g.addColorStop(0.35, rgba(col, a * 0.42)); g.addColorStop(0.7, rgba(col, a * 0.1)); g.addColorStop(1, rgba(col, 0));
    c.fillStyle = g; c.fillRect(-r, -r, r * 2, r * 2); c.restore();
  }

  /* ---------- scene painters (albedo only) ---------- */
  function wall(c, g, col) {
    c.fillStyle = col; c.fillRect(0, 0, g.w, g.h);
    var r = rng(11);
    for (var i = 0; i < 22; i++) {
      var x = r() * g.w, y = r() * g.h, rad = (0.12 + r() * 0.3) * g.w, dark = r() > 0.5;
      var gr = c.createRadialGradient(x, y, 0, x, y, rad);
      gr.addColorStop(0, dark ? 'rgba(70,52,36,.075)' : 'rgba(255,248,236,.09)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
      c.fillStyle = gr; c.fillRect(x - rad, y - rad, rad * 2, rad * 2);
    }
    var vg = c.createLinearGradient(0, 0, 0, g.h); vg.addColorStop(0, 'rgba(255,255,255,.05)'); vg.addColorStop(1, 'rgba(0,0,0,.12)');
    c.fillStyle = vg; c.fillRect(0, 0, g.w, g.h);
    grain(c, g.w, g.h, 0.3);
  }
  function arch(c, x, y, w, h) { c.beginPath(); c.moveTo(x, y + h); c.lineTo(x, y + w / 2); c.arc(x + w / 2, y + w / 2, w / 2, Math.PI, 0); c.lineTo(x + w, y + h); c.closePath(); c.fill(); }
  function circ(c, x, y, r) { c.beginPath(); c.arc(x, y, r, 0, 7); c.fill(); }
  function artA(c, x, y, w, h) {
    c.fillStyle = '#dbc6a8'; c.fillRect(x, y, w, h);
    c.fillStyle = '#b4663f'; arch(c, x + w * 0.1, y + h * 0.3, w * 0.55, h * 0.7);
    c.fillStyle = '#7d3f2a'; circ(c, x + w * 0.7, y + h * 0.27, w * 0.19);
    c.fillStyle = '#efe3d0'; arch(c, x + w * 0.58, y + h * 0.56, w * 0.34, h * 0.44);
    c.fillStyle = 'rgba(70,44,26,.25)'; arch(c, x + w * 0.2, y + h * 0.52, w * 0.2, h * 0.48);
  }
  function artB(c, x, y, w, h) {
    c.fillStyle = '#e8ddcb'; c.fillRect(x, y, w, h);
    c.fillStyle = '#c4784b'; circ(c, x + w * 0.5, y + h * 0.4, w * 0.3);
    c.fillStyle = '#8f5a3b'; c.fillRect(x, y + h * 0.7, w, h * 0.3);
    c.fillStyle = '#efe3d0'; arch(c, x + w * 0.12, y + h * 0.58, w * 0.3, h * 0.42);
    c.fillStyle = 'rgba(60,40,26,.22)'; circ(c, x + w * 0.76, y + h * 0.18, w * 0.1);
  }
  function artC(c, x, y, w, h) {
    var g = c.createLinearGradient(0, y, 0, y + h); g.addColorStop(0, '#e9dcc7'); g.addColorStop(1, '#d9c29f'); c.fillStyle = g; c.fillRect(x, y, w, h);
    c.fillStyle = '#c98253'; circ(c, x + w * 0.7, y + h * 0.36, h * 0.2);
    var cols = ['#a9703f', '#8a5a37', '#5e3e2a'];
    for (var i = 0; i < 3; i++) {
      c.fillStyle = cols[i]; c.beginPath(); c.moveTo(x, y + h);
      c.lineTo(x, y + h * (0.62 + i * 0.12));
      c.bezierCurveTo(x + w * 0.25, y + h * (0.42 + i * 0.12), x + w * 0.55, y + h * (0.78 + i * 0.05), x + w, y + h * (0.55 + i * 0.1));
      c.lineTo(x + w, y + h); c.closePath(); c.fill();
    }
  }
  function frame(c, g, x, y, w, h, paint) {
    var S = g.S, t = 1.3 * S, m = 3 * S;
    c.save(); c.shadowColor = 'rgba(0,0,0,.4)'; c.shadowBlur = 2.4 * S; c.shadowOffsetX = 0.5 * S; c.shadowOffsetY = 1 * S; c.fillStyle = '#17130f'; c.fillRect(x, y, w, h); c.restore();
    var fg = c.createLinearGradient(x, y, x + w, y + h); fg.addColorStop(0, '#2d2924'); fg.addColorStop(0.5, '#14110e'); fg.addColorStop(1, '#27231e');
    c.fillStyle = fg; c.fillRect(x, y, w, h);
    c.fillStyle = '#efe8da'; c.fillRect(x + t, y + t, w - 2 * t, h - 2 * t);
    c.fillStyle = 'rgba(0,0,0,.14)'; c.fillRect(x + t + m - 0.35 * S, y + t + m - 0.35 * S, w - 2 * (t + m) + 0.7 * S, h - 2 * (t + m) + 0.7 * S);
    c.save(); c.beginPath(); c.rect(x + t + m, y + t + m, w - 2 * (t + m), h - 2 * (t + m)); c.clip();
    paint(c, x + t + m, y + t + m, w - 2 * (t + m), h - 2 * (t + m)); c.restore();
  }
  function pillow(c, g, x, y, w, h, rot, col) {
    var S = g.S; c.save(); c.translate(x, y); c.rotate(rot);
    c.shadowColor = 'rgba(0,0,0,.35)'; c.shadowBlur = 2.4 * S; c.shadowOffsetY = 1.2 * S;
    rr(c, -w / 2, -h / 2, w, h, 5 * S); var gr = c.createLinearGradient(-w / 2, -h / 2, w / 2, h / 2);
    gr.addColorStop(0, col[0]); gr.addColorStop(1, col[1]); c.fillStyle = gr; c.fill(); c.shadowColor = 'transparent';
    c.clip(); c.strokeStyle = 'rgba(0,0,0,.14)'; c.lineWidth = 0.7 * S; c.beginPath(); c.moveTo(-w / 2, 0); c.quadraticCurveTo(0, h * 0.08, w / 2, 0); c.stroke();
    var hl = c.createRadialGradient(-w * 0.15, -h * 0.25, 0, -w * 0.15, -h * 0.25, w * 0.6); hl.addColorStop(0, 'rgba(255,255,255,.16)'); hl.addColorStop(1, 'rgba(255,255,255,0)'); c.fillStyle = hl; c.fillRect(-w, -h, w * 2, h * 2);
    c.restore();
  }
  function paintLiving(c, g) {
    wall(c, g, '#cdc3b4');
    var S = g.S, cx = g.w / 2, f = g.f, fw = 36 * f * S, fh = 50 * f * S, gap = 4 * f * S, top = g.discY - fh / 2;
    frame(c, g, cx - gap / 2 - fw, top, fw, fh, artA); frame(c, g, cx + gap / 2, top, fw, fh, artB);
    var sw = Math.min(g.W - 6, 170) * S, x = cx - sw / 2, y = 112 * S;
    c.save(); c.shadowColor = 'rgba(0,0,0,.35)'; c.shadowBlur = 5 * S; c.shadowOffsetY = -0.5 * S; rr(c, x, y, sw, 60 * S, 11 * S);
    var sg = c.createLinearGradient(0, y, 0, y + 40 * S); sg.addColorStop(0, '#a87649'); sg.addColorStop(1, '#6d4427'); c.fillStyle = sg; c.fill(); c.restore();
    c.save(); rr(c, x, y, sw, 60 * S, 11 * S); c.clip(); grain(c, g.w, g.h, 0.25);
    var hg = c.createLinearGradient(0, y, 0, y + 5 * S); hg.addColorStop(0, 'rgba(255,225,190,.32)'); hg.addColorStop(1, 'rgba(255,225,190,0)'); c.fillStyle = hg; c.fillRect(x, y, sw, 5 * S);
    c.strokeStyle = 'rgba(30,16,8,.35)'; c.lineWidth = 0.8 * S; c.beginPath(); c.moveTo(x, y + 16 * S); c.lineTo(x + sw, y + 16 * S); c.stroke();
    for (var i = 1; i < 3; i++) { c.beginPath(); c.moveTo(x + sw * i / 3, y + 16 * S); c.lineTo(x + sw * i / 3, y + 60 * S); c.stroke(); }
    c.restore();
    pillow(c, g, x + sw * 0.17, y + 5 * S, 27 * S, 24 * S, -0.12, ['#c26a42', '#9a4a2b']);
    pillow(c, g, x + sw * 0.83, y + 6 * S, 27 * S, 23 * S, 0.1, ['#e2d6c1', '#bfb29a']);
  }
  function paintBedroom(c, g) {
    wall(c, g, '#d4ccbe');
    var S = g.S, cx = g.w / 2, hb = g.hbHalf * S;
    var aw = Math.min(g.hbHalf * 2, 86) * S, ah = 30 * S * (aw / (86 * S)) + 4 * S;
    frame(c, g, cx - aw / 2, 40 * S, aw, ah, artC);
    var y = 96 * S;
    c.save(); c.shadowColor = 'rgba(0,0,0,.4)'; c.shadowBlur = 6 * S; rr(c, cx - hb, y, hb * 2, 70 * S, 7 * S);
    var hg = c.createLinearGradient(0, y, 0, y + 50 * S); hg.addColorStop(0, '#3a4b6c'); hg.addColorStop(1, '#232f47'); c.fillStyle = hg; c.fill(); c.restore();
    c.save(); rr(c, cx - hb, y, hb * 2, 70 * S, 7 * S); c.clip(); grain(c, g.w, g.h, 0.3);
    c.strokeStyle = 'rgba(0,0,0,.28)'; c.lineWidth = 0.8 * S;
    for (var i = 1; i < 6; i++) { var xx = cx - hb + (hb * 2) * i / 6; c.beginPath(); c.moveTo(xx, y); c.lineTo(xx, y + 70 * S); c.stroke(); }
    var sh = c.createLinearGradient(0, y, 0, y + 6 * S); sh.addColorStop(0, 'rgba(255,255,255,.18)'); sh.addColorStop(1, 'rgba(255,255,255,0)'); c.fillStyle = sh; c.fillRect(cx - hb, y, hb * 2, 6 * S);
    c.restore();
    var pw = Math.min(hb * 0.9, 40 * S);
    pillow(c, g, cx - hb * 0.5, y + 18 * S, pw, 22 * S, -0.04, ['#efeae0', '#cfc7b8']);
    pillow(c, g, cx + hb * 0.5, y + 18 * S, pw, 22 * S, 0.05, ['#efeae0', '#cfc7b8']);
    [-1, 1].forEach(function (s) {
      var nx = cx + s * (hb + 17 * S) - 14 * S, ny = 118 * S;
      c.save(); c.shadowColor = 'rgba(0,0,0,.35)'; c.shadowBlur = 4 * S; var ng = c.createLinearGradient(nx, 0, nx + 28 * S, 0);
      ng.addColorStop(0, '#9a7650'); ng.addColorStop(1, '#6f5236'); c.fillStyle = ng; c.fillRect(nx, ny, 28 * S, 40 * S); c.restore();
      c.fillStyle = 'rgba(255,255,255,.12)'; c.fillRect(nx, ny, 28 * S, 1.2 * S);
      c.fillStyle = 'rgba(0,0,0,.25)'; c.fillRect(nx, ny + 13 * S, 28 * S, 0.7 * S);
    });
  }

  function geometry(type, W, S) {
    var g = { type: type, S: S, W: W, w: W * S, h: 150 * S }, cx = W / 2;
    if (type === 'bedroom') {
      g.hbHalf = Math.min(58, W / 2 - 28); g.discY = 70 * S;
      var off = g.hbHalf + 17; g.discs = [{ x: (cx - off) * S, y: g.discY }, { x: (cx + off) * S, y: g.discY }];
    } else {
      g.f = Math.min(1, (W / 2 - 11 - 22) / 38); g.discY = 66 * S;
      var o2 = 38 * g.f + 22; g.discs = [{ x: (cx - o2) * S, y: g.discY }, { x: (cx + o2) * S, y: g.discY }];
    }
    return g;
  }

  /* ---------- instance ---------- */
  function init(root) {
    if (root.__kb) return; root.__kb = 1;
    var $$x = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); }, $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var stage = $('[data-kb-stage]'), canvas = $('[data-kb-canvas]'); if (!stage || !canvas) return;
    var ctx = canvas.getContext('2d'), T = {};
    try { T = JSON.parse($('[data-kb-i18n]').textContent); } catch (e) { }
    var finIdx = parseInt(root.getAttribute('data-fin-idx'), 10); if (isNaN(finIdx)) finIdx = -1;
    var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mk = function () { return document.createElement('canvas'); };
    var base = mk(), bctx = base.getContext('2d'), lc = mk(), lctx = lc.getContext('2d'), tc = mk(), tctx = tc.getContext('2d'), snap = mk(), sctx = snap.getContext('2d');
    var dpr = 1, cw = 0, ch = 0, S = 1, W = 1, geo = null;

    var st = { on: true, tone: 'warm', li: 4, left: 0, timer: 0, finish: 'black', amb: 0.32, scene: 'living' };
    var cur = { lvl: 0, c: TONES.warm.c.slice(), amb: 0.32 };
    var bars = [], ripples = [], fade = 0, raf = 0, last = 0, visible = true, started = false, ready = false, drag = null;

    function finishFromText(t) { t = (t || '').toLowerCase(); return (/gold|dor|oro|brass/.test(t) || t === 'or' || t.indexOf('or ') === 0) ? 'gold' : 'black'; }
    function selRadio() { return finIdx >= 0 ? document.querySelector('input[type=radio][name="option-' + finIdx + '"]:checked') : null; }
    var r0 = selRadio(); if (r0) st.finish = finishFromText(r0.value);

    /* layout + base */
    function layout() {
      var r = stage.getBoundingClientRect(); if (r.width < 20 || r.height < 20) return false;
      dpr = Math.min(window.devicePixelRatio || 1, 2); cw = Math.round(r.width * dpr); ch = Math.round(r.height * dpr);
      [canvas, base, lc, tc, snap].forEach(function (c) { c.width = cw; c.height = ch; });
      S = ch / 150; W = cw / S; buildScene(true); return true;
    }
    function buildScene(snapBars) {
      geo = geometry(st.scene, W, S);
      bctx.setTransform(1, 0, 0, 1, 0, 0); bctx.clearRect(0, 0, cw, ch);
      (st.scene === 'bedroom' ? paintBedroom : paintLiving)(bctx, geo);
      if (!bars.length) { bars = [0, 1].map(function (i) { return { x: geo.discs[i].x, y: geo.discs[i].y, tx: geo.discs[i].x, ty: geo.discs[i].y, disc: i, prev: i, lift: 0, tilt: 0, sc: 1, hold: false, drag: false, px: geo.discs[i].x }; }); }
      bars.forEach(function (b) {
        if (b.disc >= 0) { b.tx = geo.discs[b.disc].x; b.ty = geo.discs[b.disc].y; if (snapBars) { b.x = b.tx; b.y = b.ty; } }
        else { b.tx = clamp(b.tx, 0, cw); b.ty = clamp(b.ty, 0, ch); }
      });
    }

    /* rendering */
    function ambient() { var t = cur.amb, A = 0.05 + 0.78 * Math.pow(t, 1.35); return [255 * A * mix(0.55, 1, t), 255 * A * mix(0.68, 0.97, t), 255 * A * mix(1, 0.92, t)]; }
    function paintLight() {
      lctx.setTransform(1, 0, 0, 1, 0, 0); lctx.globalCompositeOperation = 'source-over'; lctx.fillStyle = '#000'; lctx.fillRect(0, 0, cw, ch);
      lctx.globalCompositeOperation = 'lighter';
      var gain = Math.pow(cur.lvl, 1.12), c = cur.c, n = 9, len = BAR_HALF * 2 * S;
      bars.forEach(function (b) {
        var sp = 1 + 0.32 * b.lift, al = 1 - 0.1 * b.lift;
        for (var i = 0; i < n; i++) {
          var yy = b.y - len / 2 * b.sc + (len * b.sc) * i / (n - 1);
          blob(lctx, b.x, yy, 54 * S * sp, 0.17 * gain * al, c);
          blob(lctx, b.x, yy, 25 * S * sp, 0.2 * gain * al, c);
          blob(lctx, b.x, yy, 9 * S * sp, 0.24 * gain * al, c, 0.6, 1);
        }
      });
    }
    function drawDisc(c, d, finish, lvl, rgb) {
      var R = DISC_R * S, x = d.x, y = d.y;
      c.save(); c.shadowColor = 'rgba(0,0,0,.6)'; c.shadowBlur = R * 0.6; c.shadowOffsetX = R * 0.12; c.shadowOffsetY = R * 0.22;
      c.beginPath(); c.arc(x, y, R, 0, 7); c.fillStyle = finish === 'gold' ? '#a8802f' : '#0b0b0c'; c.fill(); c.restore();
      var g = c.createRadialGradient(x - R * 0.35, y - R * 0.4, R * 0.05, x, y, R);
      if (finish === 'gold') { g.addColorStop(0, '#f6e1a6'); g.addColorStop(0.45, '#c99f4d'); g.addColorStop(1, '#7a5820'); }
      else { g.addColorStop(0, '#45484d'); g.addColorStop(0.5, '#1b1c1f'); g.addColorStop(1, '#0a0a0b'); }
      c.beginPath(); c.arc(x, y, R, 0, 7); c.fillStyle = g; c.fill();
      c.lineWidth = Math.max(1, 0.35 * S); c.strokeStyle = finish === 'gold' ? 'rgba(255,240,200,.45)' : 'rgba(255,255,255,.12)'; c.stroke();
      c.beginPath(); c.arc(x, y, R * 0.8, 0, 7); c.lineWidth = Math.max(1, 0.2 * S); c.strokeStyle = finish === 'gold' ? 'rgba(90,62,18,.35)' : 'rgba(255,255,255,.05)'; c.stroke();
      if (lvl > 0.01) {
        c.save(); c.beginPath(); c.arc(x, y, R, 0, 7); c.clip(); c.globalCompositeOperation = 'lighter';
        var w = BAR_W * S * 5, lg = c.createLinearGradient(x - w, 0, x + w, 0);
        lg.addColorStop(0, rgba(rgb, 0)); lg.addColorStop(0.5, rgba(rgb, (finish === 'gold' ? 0.16 : 0.38) * lvl)); lg.addColorStop(1, rgba(rgb, 0)); c.fillStyle = lg; c.fillRect(x - w, y - R, w * 2, R * 2);
        c.fillStyle = rgba(rgb, (finish === 'gold' ? 0.04 : 0.09) * lvl); c.fillRect(x - R, y - R, R * 2, R * 2); c.restore();
      }
      var ax = x + R * 0.62, ay = y + R * 0.62; c.beginPath(); c.arc(ax, ay, Math.max(1.2, 0.34 * S), 0, 7); c.fillStyle = finish === 'gold' ? 'rgba(80,56,16,.6)' : 'rgba(255,255,255,.18)'; c.fill();
    }
    function drawBar(c, b, finish, lvl, rgb) {
      var Lh = BAR_HALF * S, w = Math.max(3.4 * dpr, BAR_W * S);
      c.save(); c.translate(b.x, b.y); c.rotate(b.tilt); c.scale(b.sc, b.sc);
      if (b.lift > 0.02) { c.shadowColor = 'rgba(0,0,0,' + (0.55 * b.lift) + ')'; c.shadowBlur = 16 * dpr * b.lift; c.shadowOffsetX = 7 * dpr * b.lift; c.shadowOffsetY = 12 * dpr * b.lift; }
      rr(c, -w / 2, -Lh, w, Lh * 2, w / 2);
      var g = c.createLinearGradient(-w / 2, 0, w / 2, 0);
      if (finish === 'gold') { g.addColorStop(0, '#f3d994'); g.addColorStop(0.5, '#b98d3e'); g.addColorStop(1, '#6a4a18'); } else { g.addColorStop(0, '#34363a'); g.addColorStop(0.45, '#0c0c0d'); g.addColorStop(1, '#050505'); }
      c.fillStyle = g; c.fill(); c.shadowColor = 'transparent';
      if (lvl > 0.01) {
        c.globalCompositeOperation = 'lighter'; var lw = Math.max(1.2 * dpr, 0.3 * S);
        [-1, 1].forEach(function (s) {
          c.beginPath(); c.moveTo(s * w / 2, -Lh + w / 2); c.lineTo(s * w / 2, Lh - w / 2); c.lineWidth = lw; c.lineCap = 'round';
          c.strokeStyle = rgba(rgb, Math.min(1, 0.95 * lvl + 0.05)); c.shadowColor = rgba(rgb, 1); c.shadowBlur = (6 + 14 * lvl) * dpr; c.stroke();
        });
        var cg = c.createLinearGradient(0, -Lh, 0, Lh); cg.addColorStop(0, rgba(rgb, 0)); cg.addColorStop(0.5, rgba(rgb, 0.22 * lvl)); cg.addColorStop(1, rgba(rgb, 0));
        c.shadowColor = 'transparent'; c.fillStyle = cg; c.fillRect(-w * 0.35, -Lh, w * 0.7, Lh * 2);
      }
      c.restore();
    }
    function render(now) {
      var c = ctx; c.setTransform(1, 0, 0, 1, 0, 0); c.globalCompositeOperation = 'source-over'; c.globalAlpha = 1; c.shadowColor = 'transparent';
      c.drawImage(base, 0, 0);
      var a = ambient(); c.globalCompositeOperation = 'multiply'; c.fillStyle = 'rgb(' + (a[0] | 0) + ',' + (a[1] | 0) + ',' + (a[2] | 0) + ')'; c.fillRect(0, 0, cw, ch);
      if (cur.lvl > 0.004) {
        paintLight(); tctx.globalCompositeOperation = 'source-over'; tctx.drawImage(base, 0, 0); tctx.globalCompositeOperation = 'multiply'; tctx.drawImage(lc, 0, 0);
        c.globalCompositeOperation = 'lighter'; c.drawImage(tc, 0, 0);
      }
      c.globalCompositeOperation = 'source-over';
      var lvl = cur.lvl, rgb = cur.c;
      geo.discs.forEach(function (d) { drawDisc(c, d, st.finish, lvl, rgb); });
      /* magnet hint */
      if (drag) {
        geo.discs.forEach(function (d) {
          var dist = Math.hypot(drag.x - d.x, drag.y - d.y), r = 20 * S, k = clamp(1 - (dist - r) / (r * 2), 0, 1);
          if (k > 0) { c.save(); c.setLineDash([3 * dpr, 4 * dpr]); c.lineWidth = 1.4 * dpr; c.strokeStyle = 'rgba(210,165,102,' + (0.25 + 0.6 * k) + ')'; c.beginPath(); c.arc(d.x, d.y, DISC_R * S * (1.5 + 0.3 * k), 0, 7); c.stroke(); c.restore(); }
        });
      }
      var order = bars.slice().sort(function (p, q) { return p.lift - q.lift; });
      order.forEach(function (b) { drawBar(c, b, st.finish, lvl, rgb); });
      if (lvl > 0.01) {
        c.globalCompositeOperation = 'lighter';
        bars.forEach(function (b) { blob(c, b.x, b.y, 17 * S, 0.14 * lvl, rgb, 0.45, 1.5); });
        c.globalCompositeOperation = 'source-over';
      }
      /* ripples */
      for (var i = ripples.length - 1; i >= 0; i--) {
        var r = ripples[i], t = r.t / r.d; if (t >= 1) { ripples.splice(i, 1); continue; }
        c.save(); c.lineWidth = (r.k === 'ir' ? 1.6 : 2) * dpr; c.globalCompositeOperation = 'lighter';
        c.strokeStyle = r.k === 'ir' ? rgba(rgb, 0.55 * (1 - t)) : 'rgba(255,226,170,' + 0.7 * (1 - t) + ')';
        c.beginPath(); c.arc(r.x, r.y, (r.k === 'ir' ? mix(8, 46, t) : mix(DISC_R, DISC_R * 2.4, t)) * (r.k === 'ir' ? dpr : S), 0, 7); c.stroke(); c.restore();
      }
      /* vignette */
      var vg = c.createRadialGradient(cw / 2, ch * 0.5, Math.min(cw, ch) * 0.35, cw / 2, ch * 0.5, Math.max(cw, ch) * 0.78);
      vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(0,0,0,.38)'); c.fillStyle = vg; c.fillRect(0, 0, cw, ch);
      if (fade > 0) { c.globalAlpha = fade; c.drawImage(snap, 0, 0); c.globalAlpha = 1; }
    }

    /* animation loop */
    function tgtLvl() { return st.on && started ? STEPS[st.li] : 0; }
    function tgtColor() { return TONES[st.tone].c; }
    function tick(now) {
      raf = 0; var dt = Math.min(64, now - (last || now)); last = now; if (!dt) dt = 16;
      var busy = false, kk = reduced ? 1 : 1 - Math.exp(-dt / 120);
      var tl = tgtLvl(); cur.lvl += (tl - cur.lvl) * kk; if (Math.abs(tl - cur.lvl) > 0.002) busy = true; else cur.lvl = tl;
      var tcol = tgtColor(); for (var i = 0; i < 3; i++) { cur.c[i] += (tcol[i] - cur.c[i]) * kk; if (Math.abs(tcol[i] - cur.c[i]) > 0.5) busy = true; else cur.c[i] = tcol[i]; }
      cur.amb += (st.amb - cur.amb) * (reduced ? 1 : 1 - Math.exp(-dt / 160)); if (Math.abs(st.amb - cur.amb) > 0.002) busy = true; else cur.amb = st.amb;
      bars.forEach(function (b) {
        var k = reduced ? 1 : 1 - Math.exp(-dt / (b.drag ? 40 : 90));
        b.px = b.x; b.x += (b.tx - b.x) * k; b.y += (b.ty - b.y) * k;
        var vx = (b.x - b.px) / (dt / 16.7) / dpr, tt = reduced ? 0 : clamp(vx * 0.014, -0.2, 0.2); b.tilt += (tt - b.tilt) * 0.25;
        var lt = (b.drag || b.hold || b.disc < 0) ? 1 : 0; b.lift += (lt - b.lift) * (reduced ? 1 : 1 - Math.exp(-dt / 90)); if (Math.abs(lt - b.lift) < 0.01) b.lift = lt;
        b.sc = 1 + 0.07 * b.lift;
        if (Math.abs(b.tx - b.x) > 0.4 || Math.abs(b.ty - b.y) > 0.4 || Math.abs(b.tilt) > 0.002 || b.lift !== lt) busy = true;
      });
      ripples.forEach(function (r) { r.t += dt; }); if (ripples.length) busy = true;
      if (fade > 0) { fade = Math.max(0, fade - dt / 380); busy = true; }
      if (visible) render(now);
      if (busy || drag) schedule();
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(tick); }
    function kick() { last = 0; schedule(); }

    /* UI state */
    var elK = $('[data-kb-k]'), elL = $('[data-kb-l]'), elS = $('[data-kb-status]'), elT = $('[data-kb-timer]'), segs = $$('[data-kb-segs] i'), ir = $('[data-kb-ir]');
    function fmt(s, m) { return (s || '').replace('{m}', m); }
    function ui() {
      var tone = TONES[st.tone], tl = T.tones && T.tones[st.tone] || {};
      if (elK) elK.textContent = st.on ? tone.k + ' K' : (T.off || 'Off');
      if (elL) elL.textContent = st.on ? (tl.label || st.tone) + ' · ' + Math.round(STEPS[st.li] * 100) + '%' : (T.standby || '');
      var lifted = bars.some(function (b) { return b.disc < 0 || b.hold; });
      if (elS) elS.textContent = lifted ? (T.lifted || '') : (T.docked || '');
      if (elS) elS.setAttribute('data-lifted', lifted ? '1' : '0');
      segs.forEach(function (s, i) { s.classList.toggle('is-on', st.on && i <= st.li); });
      $$('[data-kb-act="tone"]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === st.tone ? 'true' : 'false'); });
      $$('[data-kb-act="timer"]').forEach(function (b) { b.setAttribute('aria-pressed', st.timer && parseInt(b.getAttribute('data-v'), 10) === st.timer ? 'true' : 'false'); });
      $$('[data-kb-act="power"]').forEach(function (b) { b.setAttribute('aria-pressed', st.on ? 'true' : 'false'); });
      $$('[data-kb-fin]').forEach(function (b) { b.setAttribute('aria-pressed', finishFromText(b.getAttribute('data-val')) === st.finish ? 'true' : 'false'); });
      $$('[data-kb-scene]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kb-scene') === st.scene ? 'true' : 'false'); });
      var lb = $('[data-kb-act="lift"]'); if (lb) { var h0 = bars[0] && bars[0].hold; lb.setAttribute('aria-pressed', h0 ? 'true' : 'false'); lb.textContent = h0 ? (T.putback || '') : (T.liftoff || ''); }
      if (elT) { if (st.timer && st.left > 0 && st.on) { elT.hidden = false; elT.textContent = fmt(T.timer, st.left); } else { elT.hidden = true; } }
    }
    function fireIR() {
      if (ir) { ir.classList.add('is-fire'); setTimeout(function () { ir.classList.remove('is-fire'); }, 160); }
      bars.forEach(function (b) { ripples.push({ x: b.x, y: b.y, t: 0, d: 520, k: 'ir' }); });
    }
    var tickTimer = setInterval(function () {
      if (st.timer && st.on && st.left > 0) { st.left--; if (st.left <= 0) { st.on = false; st.timer = 0; kick(); } ui(); }
    }, 1000);

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-kb-act],[data-kb-fin],[data-kb-scene]'); if (!t || !root.contains(t)) return;
      var act = t.getAttribute('data-kb-act');
      if (act === 'power') { st.on = !st.on; if (st.on) { st.timer = 0; st.left = 0; } else { st.timer = 0; st.left = 0; } fireIR(); }
      else if (act === 'tone') { st.tone = t.getAttribute('data-v'); if (!st.on) st.on = true; fireIR(); }
      else if (act === 'dim') { var d = parseInt(t.getAttribute('data-v'), 10); st.on = true; st.li = clamp(st.li + d, 0, STEPS.length - 1); fireIR(); }
      else if (act === 'timer') { var m = parseInt(t.getAttribute('data-v'), 10); if (st.timer === m) { st.timer = 0; st.left = 0; } else { st.timer = m; st.left = m; st.on = true; } fireIR(); }
      else if (act === 'lift') { var b0 = bars[0]; if (b0.hold) { dock(b0, b0.prev >= 0 ? b0.prev : 0); } else { b0.prev = b0.disc >= 0 ? b0.disc : b0.prev; b0.disc = -1; b0.hold = true; var d0 = geo.discs[b0.prev]; b0.tx = d0.x + 14 * S; b0.ty = d0.y - 18 * S; } }
      else if (t.hasAttribute('data-kb-fin')) {
        st.finish = finishFromText(t.getAttribute('data-val'));
        var rad = null, val = t.getAttribute('data-val') || ''; if (finIdx >= 0) { $$x('input[type=radio][name="option-' + finIdx + '"]').forEach(function (r) { if (r.value === val) rad = r; }); }
        if (rad && !rad.checked) { rad.checked = true; rad.dispatchEvent(new Event('change', { bubbles: true })); }
      } else if (t.hasAttribute('data-kb-scene')) {
        var ns = t.getAttribute('data-kb-scene'); if (ns !== st.scene) { sctx.setTransform(1, 0, 0, 1, 0, 0); sctx.globalCompositeOperation = 'source-over'; sctx.clearRect(0, 0, cw, ch); sctx.drawImage(canvas, 0, 0); fade = reduced ? 0 : 1; st.scene = ns; buildScene(false); }
      }
      ui(); kick();
    });
    document.addEventListener('change', function (e) {
      var t = e.target; if (t && t.type === 'radio' && finIdx >= 0 && t.name === 'option-' + finIdx && t.checked) { var f = finishFromText(t.value); if (f !== st.finish) { st.finish = f; ui(); kick(); } }
    });
    var amb = $('[data-kb-amb]');
    if (amb) amb.addEventListener('input', function () { st.amb = clamp(parseInt(amb.value, 10) / 100, 0, 1); kick(); });

    /* dock + drag */
    function dock(b, idx) {
      var occ = bars.filter(function (o) { return o !== b && o.disc === idx; })[0];
      if (occ) { var back = b.prev >= 0 ? b.prev : 1 - idx; occ.disc = back; occ.hold = false; occ.tx = geo.discs[back].x; occ.ty = geo.discs[back].y; }
      b.disc = idx; b.prev = idx; b.hold = false; b.tx = geo.discs[idx].x; b.ty = geo.discs[idx].y;
      ripples.push({ x: geo.discs[idx].x, y: geo.discs[idx].y, t: 0, d: 480, k: 'dock' }); ui(); kick();
    }
    function pt(e) { var r = canvas.getBoundingClientRect(); return { x: (e.clientX - r.left) * dpr, y: (e.clientY - r.top) * dpr }; }
    function hit(p) {
      for (var i = bars.length - 1; i >= 0; i--) { var b = bars[i]; if (Math.abs(p.x - b.x) < 22 * dpr + BAR_W * S && Math.abs(p.y - b.y) < BAR_HALF * S * b.sc + 6 * dpr) return b; }
      return null;
    }
    canvas.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { var t = e.touches[0], p = pt(t); if (hit(p)) e.preventDefault(); } }, { passive: false });
    canvas.addEventListener('pointerdown', function (e) {
      var p = pt(e), b = hit(p); if (!b) return;
      b.prev = b.disc >= 0 ? b.disc : b.prev; b.disc = -1; b.drag = true; b.hold = false; drag = { b: b, ox: b.x - p.x, oy: b.y - p.y, x: b.x, y: b.y };
      try { canvas.setPointerCapture(e.pointerId); } catch (x) { } canvas.style.cursor = 'grabbing'; ui(); kick(); e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) {
      var p = pt(e);
      if (drag) { var b = drag.b; b.tx = clamp(p.x + drag.ox, 8 * dpr, cw - 8 * dpr); b.ty = clamp(p.y + drag.oy, BAR_HALF * S * 0.4, ch - 6 * dpr); drag.x = b.tx; drag.y = b.ty; kick(); }
      else canvas.style.cursor = hit(p) ? 'grab' : '';
    });
    function up(e) {
      if (!drag) return; var b = drag.b, best = -1, bd = 1e9;
      geo.discs.forEach(function (d, i) { var dd = Math.hypot(b.tx - d.x, b.ty - d.y); if (dd < bd) { bd = dd; best = i; } });
      b.drag = false; drag = null; canvas.style.cursor = '';
      dock(b, bd < 22 * S ? best : (b.prev >= 0 ? b.prev : 0));
    }
    canvas.addEventListener('pointerup', up); canvas.addEventListener('pointercancel', up);

    /* lifecycle */
    function boot() {
      if (!layout()) return false; ui(); ready = true; render(performance.now()); return true;
    }
    if ('ResizeObserver' in window) { new ResizeObserver(function () { if (!ready) { boot(); } else { layout(); kick(); } }).observe(stage); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          visible = en.isIntersecting; if (visible) { if (!started) { started = true; if (!reduced) { cur.lvl = 0; } else { cur.lvl = tgtLvl(); } } if (!ready) boot(); kick(); }
        });
      }, { threshold: 0.2 }).observe(stage);
    } else { started = true; boot(); kick(); }
    if (!boot()) { window.addEventListener('load', function () { boot(); kick(); }); }
    window.__kbDebug = function () { return { st: st, cur: cur, bars: bars, geo: geo, S: S, dpr: dpr }; };
  }

  function go() { Array.prototype.forEach.call(document.querySelectorAll('[data-kb]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
